import AlertService from "@/services/alert/alert.service";

export const alert = {
    namespaced: true,
    state: {
        list: [],
        savedAlert: null,
        showAlert: null,
        receivedAlerts: [],
        changeReadedAlert: null,
        lastAlert: null,
        showingLastAlertIcon: false,
        alertCount: 0,
        alertTypes: []
    },
    actions: {
        getAlerts({commit}) {
            return AlertService.getAlertList()
                .then(
                    alerts => {
                        commit('alertListFetchSuccess', alerts)
                    },
                    error => {
                        commit('alertsListFetchFail', error)
                    }
                )
        },
        getAlertTypes({commit}) {
            return AlertService.getAlertTypes()
                .then(
                    alertTypes => {
                        commit('alertTypesFetchSuccess', alertTypes)
                    },
                    error => {
                        commit('alertsListFetchFail', error)
                    }
                )
        },
        saveAlert({commit}, data) {
            return AlertService.saveAlert(data)
                .then(
                    savedAlert => {
                        commit('alertSaveSuccess', savedAlert)
                    },
                    error => {
                        commit('alertsListFetchFail', error)
                    }
                )
        },
        makeAlertReaded({commit}, alertId) {
            return AlertService.makeReaded(alertId).then(
                alert => {
                    commit('alertReadedSuccess', alert)
                },
                error => {
                    commit('alertsListFetchFail', error)
                }
            )
        },
        makeReadedAllAlert({commit}) {
            return AlertService.makeReadedAllAlert().then(
                alert => {
                    commit('alertAllReadedSuccess', alert)
                },
                error => {
                    commit('alertsListFetchFail', error)
                }
            )
        },
        showAlert({commit}, alertId) {
            return AlertService.showAlert(alertId)
                .then(
                    showAlert => {
                        commit('alertShowSuccess', showAlert)
                    },
                    error => {
                        commit('alertsListFetchFail', error)
                    }
                )
        },
        deleteAlert({commit}, alertId) {
            return AlertService.deleteAlert(alertId)
                .then(
                    deletedAlert => {
                        commit('alertDeletedSuccess', deletedAlert)
                    },
                    error => {
                        commit('alertsListFetchFail', error)
                    }
                )
        },
        getReceivedAlerts({commit}, data) {
            return AlertService.receivedAlerts(data)
                .then(
                    receivedAlerts => {
                        commit('fetchReceivedAlerts', receivedAlerts)
                    },
                    error => {
                        commit('alertsListFetchFail', error)
                    }
                )
        },
        getLastAlert({commit}) {
            if (this.state.user && this.state.user.me) {
                return AlertService.getLastAlert()
                    .then(
                        lastAlert => {
                            commit('fetchLastAlert', lastAlert)
                        },
                        error => {
                            commit('alertsListFetchFail', error)
                        }
                    )
            }
        },
        unreadedAlertcount({commit}) {
            return AlertService.countUnreadAlert().then(
                alertCount => {
                    commit('alertCountFetch', alertCount)
                },
                error => {
                    commit('alertsListFetchFail', error)
                }
            )
        }
    },
    mutations: {
        alertListFetchSuccess(state, alerts) {
            state.list = alerts
        },
        alertTypesFetchSuccess(state, alertTypes) {
            state.alertTypes = alertTypes.data.alertTypes
        },
        alertSaveSuccess(state, savedAlert) {
            if (state.list.data.list) {
                let index = state.list.data.list.findIndex(item => item.id === savedAlert.data.alert.id);
                if (index !== -1) {
                    state.list.data.list[index] = savedAlert.data.alert
                } else {
                    state.list.data.list.unshift(savedAlert.data.alert)
                }
            }
            state.savedAlert = savedAlert
        },
        alertReadedSuccess(state, alert) {
            if (state.receivedAlerts && state.receivedAlerts.data) {
                let index = state.receivedAlerts.data.alerts.data.findIndex(item => item.id === alert.data.alert.id)
                state.receivedAlerts.data.alerts.data[index] = alert.data.alert
                state.changeReadedAlert = alert
            }
        },
        alertAllReadedSuccess(state, success) {
            state.receivedAlerts = []
            console.log(state, success)
        },
        alertShowSuccess(state, showAlert) {
            state.showAlert = showAlert
        },
        alertDeletedSuccess(state, deletedAlert) {
            let index = state.list.data.list.findIndex(item => item.id === parseInt(deletedAlert.data.alertId));
            state.list.data.list.splice(index, 1);
            state.alertDeleted = deletedAlert
        },
        fetchReceivedAlerts(state, receivedAlerts) {
            state.receivedAlerts = receivedAlerts
        },
        fetchLastAlert(state, lastAlert) {
            state.lastAlert = lastAlert
        },
        alertCountFetch(state, alertCount) {
            state.alertCount = alertCount
        },
        alertsListFetchFail(state, error) {
            state.error = error
        }
    }
}